import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import Loader from "./Component/loader";
import Test from "./Component/header";
const Landing = lazy(() => import("./Routes/landing"));
const Contact = lazy(() => import("./Routes/contact"));
const Darkroom = lazy(() => import("./darkroom"));
const Projects = lazy(() => import("./Routes/projects"));
class ErrorHandler extends React.Component {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError(err) {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <p>Loading has failed. Try refreshing the browser!</p>;
    }

    return this.props.children;
  }
}

function App() {
  let routes = (
    <Routes>
      <Route exact path="/" element={<Landing />}></Route>
      <Route exact path="/contact" element={<Contact />}></Route>
      <Route exact path="/desc" element={<Test />}></Route>
      <Route exact path="/darkroom" element={<Darkroom />}></Route>
      <Route exact path="/projects" element={<Projects />}></Route>
    </Routes>
  );
  return (
    <ErrorHandler>
      <Suspense fallback={null}>{routes}</Suspense>
    </ErrorHandler>
  );
}

export default App;
